/* Sooler Studio: mobile collection descriptions clamp to two lines. */
(() => {
  const SELECTOR = '[data-sooler-collection-description]';
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  const setup = (container) => {
    if (container.dataset.soolerDescriptionReady === 'true') return;
    const copy = container.querySelector('[data-sooler-collection-description-copy]');
    const toggle = container.querySelector('[data-sooler-collection-description-toggle]');
    const label = container.querySelector('[data-sooler-collection-description-label]');
    if (!copy || !toggle || !label) return;

    container.dataset.soolerDescriptionReady = 'true';

    const setExpanded = (expanded) => {
      container.classList.toggle('is-expanded', expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? 'Weniger anzeigen' : 'Mehr anzeigen';
    };

    const refresh = () => {
      if (!mobileQuery.matches) {
        setExpanded(false);
        toggle.hidden = true;
        return;
      }

      setExpanded(false);
      toggle.hidden = true;
      requestAnimationFrame(() => {
        toggle.hidden = copy.scrollHeight <= copy.clientHeight + 1;
      });
    };

    toggle.addEventListener('click', () => setExpanded(!container.classList.contains('is-expanded')));
    window.addEventListener('resize', refresh, { passive: true });
    document.fonts?.ready?.then(refresh);
    refresh();
  };

  const initialize = (root = document) => {
    if (root.matches?.(SELECTOR)) setup(root);
    root.querySelectorAll?.(SELECTOR).forEach(setup);
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
